import { render, staticRenderFns } from "./configure-type.vue?vue&type=template&id=ae7af852&scoped=true&"
import script from "./configure-type.vue?vue&type=script&lang=ts&"
export * from "./configure-type.vue?vue&type=script&lang=ts&"
import style0 from "./configure-type.vue?vue&type=style&index=0&id=ae7af852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7af852",
  null
  
)

export default component.exports